// AccidentsDashboardBlade/index.js
import React, {useState} from 'react';
import { Paper, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import moment from 'moment';

import DashboardCountBox from '../DashboardCountBox';
import { buttonNames } from '../../../constants';
import { injuryMappers } from '../../../mappers';
import { utcToLocal } from './../../../utils/timeConverter';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 16,
    margin: 16
  },
  titleContainer: {
    position: 'relative',
    top: -16
  },
  bladeIcon: {
    position: 'absolute'
  },
  bladeTitle: {
    marginTop: -4,
    position: 'absolute',
    left: 32,
    top: 6
  },
  countBoxContainer: {
    display: 'flex',
    marginTop: 24
  },
  countBox: {
    width: '100%'
  },
  container: {
    borderBottom: `1px solid ${theme.palette.lightGrey.default}`,
    padding: '10px 16px 10px 0',
    display: 'flex',
    justifyContent: 'space-between'
  },
  heading: {
    fontWeight: 600
  },
  textContent: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  buttonContent: {},
  seeMoreButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8
  },
  seeMoreButton: {
    background: '#54a000',
    color: 'white',
    width: 150,
    height: 36,
    '&:hover': {
      background: 'white',
      color: '#54a000',
      border: '1px solid #54a000'
    }
  },
  noRecords: {
    fontSize: 20,
    textAlign: 'center',
    color: '#424242',
    marginBottom: 0
  },
  accidentDate: {
    margin: 0,
    marginTop: 8
  }
}));

function AccidentsDashboardBlade(props) {
  const classes = useStyles();

  const {
    fetchAllAccidentsForBranch,
    branchId,
    allAccidents,
    setCurrentBranchesRecord
  } = props;

  const[seeMore, setSeeMore] = useState(true);

  let accidents = allAccidents;

  React.useEffect(
    () => {
      if (branchId) {
        fetchAllAccidentsForBranch(branchId);
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [branchId]
  );

  if (accidents.length > 0) {
    //Order courses based on date
    accidents &&
      accidents.sort(function (a, b) {
        return new Date(b.injuryDate) - new Date(a.injuryDate);
      });

    //Calculating accidents in last 6 months.
    const last6MonthsDate = moment().subtract(6, 'months');
    accidents = accidents.filter(
      (accident) => new Date(accident.injuryDate) > last6MonthsDate
    );
  }

  const formattedTime = (accident) => {
    const convertedTime = utcToLocal(accident.injuryDate);
    let secondes = convertedTime.get('second');
    if (secondes > 0) {
      return convertedTime.format('DD/MM/YYYY hh:mm A');
    } else {
      return convertedTime.format('DD/MM/YYYY');
    }
  };

  const handleSeeMoreButtonForAccidentsClick = (recordType) => {
    setSeeMore(false);
  };

  const handleSeeLessButtonForAccidentsClick = (recordType) => {
    setSeeMore(true);
  };

  return (
    <Paper className={classes.paper}>
      <React.Fragment>
        <h3 className={classes.titleContainer}>
          <WarningIcon className={classes.bladeIcon} />
          <span className={classes.bladeTitle}>Accidents</span>
        </h3>

        <div className={classes.countBoxContainer}>
          <div className={classes.countBox}>
            <DashboardCountBox
              count={accidents.length}
              label="in last 6 months"
            />
          </div>
        </div>

        {accidents &&
          accidents.map((accident, index) => {
            //Because only 3 items are to be shown.
            if (seeMore && index > 4) {
              return null;
            }

            return (
              <div className={classes.container} key={index}>
                <div className={classes.textContent}>
                  <Typography variant="h6" className={classes.heading}>
                    {injuryMappers.mapInjuryTypeToText(accident.injuryTypeId)}
                  </Typography>
                  <p className={classes.accidentDate}>
                    {accident && formattedTime(accident)}{' '}
                  </p>
                </div>
              </div>
            );
          })}

        {accidents.length > 5 ? (
          <div className={classes.seeMoreButtonContainer}>
            {seeMore ? (<Button
              color="secondary"
              className={classes.seeMoreButton}
              onClick={() =>
                handleSeeMoreButtonForAccidentsClick(buttonNames.ACCIDENTS)
              }
            >
              See More
            </Button>) : (<Button
              color="secondary"
              className={classes.seeMoreButton}
              onClick={() =>
                handleSeeLessButtonForAccidentsClick(buttonNames.ACCIDENTS)
              }
            >
              See Less
            </Button>) }
          </div>
        ) : null}
      </React.Fragment>
    </Paper>
  );
}

export default AccidentsDashboardBlade;
